import React, { useState } from 'react';
import DateInput from '../../../../common/DateInput'
import DatePicker from "react-datepicker";
import Paginator from '../../../../common/Paginator'

const EditServices = ({ accomplishments, setAccomplishments, index, setIndex, addAccomplishments }) => {
    var accomplishment = accomplishments[index]
    return (
        <div >
        <div className="mg-b-5 mg-t-15">
                <div className="modal-subheader">Organization</div>                
                <div className="mg-b-15"><input   value={accomplishment.association} onChange={(e) => setAccomplishments(e.target.value, "association")} type="text" className="form-control"></input></div>
                <div className="modal-subheader">Location</div>
                <div className="row mg-b-15">
                    <div className="col-md-6">   
                    <div className="modal-sublistheader mg-t-0">City/State</div>
                    <div><input value={accomplishment.city} onChange={(e) => setAccomplishments(e.target.value, "city")} type="text" className="form-control"></input></div> 
                    </div>
                    <div className="col-md-6">
                    <div className="modal-sublistheader mg-t-0">Country</div>
                    <div><input value={accomplishment.country} onChange={(e) => setAccomplishments(e.target.value, "country")} type="text" className="form-control"></input></div>
                    </div>   
                </div>   
                
                <div className="modal-subheader">Role</div>
            <div>
                <textarea  value={accomplishment.description} onChange={(e) => setAccomplishments(e.target.value, "description")} className="textarea" style={{marginTop:'0px', marginBottom:'0px', height:'70px'}}></textarea>
            </div>
        </div>
        <div className="v-align">
                <div className="wd-pct-33">
                    <Paginator index={index} length={accomplishments.length} onClick={setIndex}/>
                </div>
                <div className="wd-pct-33 text-center">{"Showing " + (index + 1) + " of " + accomplishments.length}</div>
                <div style={{marginLeft:'auto'}}>
                    <button className="btn btn-mini btn-default"  onClick={addAccomplishments}>
                        <i className="fas fa-plus mg-r-5"></i>Add Service
                        <span className="button-info">3</span>
                    </button>
                </div>
        </div>
  </div>   
)}
export default EditServices;